import {
  WarningRounded,
  FiberManualRecord,
  AccountCircleOutlined,
} from "@material-ui/icons";
import { withStyles, Badge } from "@material-ui/core";
import { compose } from "recompose";
import Tooltip from "../../../../common/StyledToolTip";
import { pluralize } from "../util";
import { format } from "date-fns";
import reportConstants from "../constants"
import colors from "../styleColors";
const styles = {
  //theme is not supported in gantt chart hence not using theme object for styling.
  gridCardContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: 100,
    padding: 8,
    cursor: "pointer",
  },
  driverDetails: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: -6,
  },
  driverNameIconContainer: {
    display: "flex",
    alignItems: "center",
    color: colors.lightGrey,
    fontSize: 12,
  },
  driverIcon: {
    fontSize: 30,
  },
  driverName: {
    fontWeight: 600,
    lineHeight: 3,
    marginLeft: 4,
  },
  cardActions: {
    display: "flex",
    width: 80,
    justifyContent: "flex-end",
    marginRight: 12,
  },
  actionIcon: {
    cursor: "pointer",
    color: colors.lightGrey,
    pointerEvents: "none",
  },
  warningIcon: {
    color: "#F5A623",
  },
  driverStatusContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: 32,
  },
  statusIconDelayed: {
    color: colors.delayedColor,
    fontSize: 12,
  },
  statusIconOnTime: {
    color: colors.primaryAppColor,
    fontSize: 12,
  },
  statusIndicatorIcon: { display: "flex", marginLeft: 28, marginTop: 8 },
  margin: {
    margin: 0,
  },
  customBadge: {
    color: "#C9830E",
    backgroundColor: "#ffffff",
    boxShadow: "0px 1px 6px rgb(0 0 0 / 20%)",
    height: "14px",
    minWidth: "14px",
    borderRadius: "7px",
    fontSize: 10,
    transform: "scale(1) translate(13%, 2%)",
    fontWeight: 700,
    lineHeight: 2,
  },
  statusLabel: {
    lineHeight: 1,
    fontSize: 10,
    fontWeight: 600,
    marginLeft: 6,
  },
  delayedRow: {
    color: colors.delayedColor,
  },
  onTimeRow: {
    color: colors.primaryAppColor,
  },
  trialerTypeIconContainer: {
    display: "flex",
    alignItems: "center",
    marginLeft: 28,
    marginTop: 6,
  },
  dateStyle: {
    marginTop: 8,
    alignSelf: "flex-start",
    marginLeft: 32,
    lineHeight: 1,
    fontSize: 10,
    fontWeight: 600,
  },
};

const tooltipStyles = () => ({
  tooltip: {
    backgroundColor: "#EFEFEE",
    color: "#3E3E3E",
  },
  tooltipPlacementBottom: {
    margin: 4,
  },
});

const StyledToolTip = withStyles(tooltipStyles)(Tooltip); // override tooltip styles to support gantt lib styling.

const DriverColumnCard = ({ data, classes }) => {
  const { driverRoutesData } = data;
  const totalReturns = driverRoutesData.reduce((acc, route) => {
    if (route.numberOfReturnShipments) {
      return acc + route.numberOfReturnShipments;
    }
    return acc;
  }, 0);
  return (
    <div className={classes.gridCardContainer}>
      <div id="driverDetails" className={classes.driverDetails}>
        <div className={classes.driverNameIconContainer}>
          <AccountCircleOutlined className={classes.driverIcon} />
          <span className={classes.driverName}>{data.text}</span>
        </div>
        <div className={classes.cardActions}>
          {totalReturns ? (
            <div>
              <StyledToolTip
                disableFocusListener={true}
                title={pluralize(totalReturns, "RETURN")}
              >
                <span>
                  <Badge
                    className={classes.margin}
                    classes={{ badge: classes.customBadge }}
                    badgeContent={totalReturns}
                  >
                    <WarningRounded
                      className={`${classes.warningIcon} ${classes.actionIcon}`}
                    />
                  </Badge>
                </span>
              </StyledToolTip>
            </div>
          ) : null}
        </div>
      </div>
      <div id="driverStatus" className={classes.driverStatusContainer}>
        {data.isRealtimeReport && (
          <>
            <FiberManualRecord
              className={
                data.isDriverDelayed
                  ? classes.statusIconDelayed
                  : classes.statusIconOnTime
              }
            />
            <span
              className={`${classes.statusLabel} ${
                data.isDriverDelayed ? classes.delayedRow : classes.onTimeRow
              }`}
            >
              {data.isDriverDelayed ? "Behind Schedule" : "On Track"}
            </span>
          </>
        )}
      </div>
      {data.isLiftGateRequired && (
        <div id="trailerType" className={classes.trialerTypeIconContainer}>
          <StyledToolTip disableFocusListener={true} title="LG">
            <i className="icon-liftgate" />
          </StyledToolTip>
        </div>
      )}
      {!data.isRealtimeReport && (
        <span className={classes.dateStyle}>
          {format(
            data.dispatchDate,
            reportConstants.REPORT_DISPLAY_DATE_FORMAT
          )}
        </span>
      )}
    </div>
  );
};

export default compose(withStyles(styles))(DriverColumnCard);
